import clsx from 'clsx';

export const FieldWrapper = (props) => {
  const { label, className, error, children } = props;
  return (
    <div className="mb-4">
      <div
        className={clsx(
          'block text-sm font-medium text-white/80',
          className
        )}
      >
        {label && <div className="ml-2 mb-1">{label}</div>}
        <div className="">
          {children}
        </div>
      </div>
      {error?.message && (
        <div
          role="alert"
          aria-label={error.message}
          className="mx-2 mt-1 text-sm font-semibold text-red-500"
        >
          {error.message}
        </div>
      )}
    </div>
  );
};
